// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Direction of the target channel side the modifier applies to.
 */
export enum ModifierDirection {
  OUTBOUND = 0,
  INBOUND = 1,
}
